(function( app, marketinOffer, $, undefined ) {
  'use strict';

  const formElements = {
    'enable_internal_deep_link': '#marketing_offer_marketing_offer_detail_attributes_use_internal_deep_link',
    'external_deep_link_wrapper': '#marketing_offer_marketing_offer_detail_attributes_external_link_url_input',
    'internal_deep_link_wrapper': '#marketing_offer_marketing_offer_detail_attributes_deep_link_input',
    'deep_link_resource': '#marketing_offer_marketing_offer_detail_attributes_deep_link_id',
    'deep_link_member_resource_wrapper': '#marketing_offer_marketing_offer_detail_attributes_deep_link_member_id_input',
    'deep_link_member_resource': '#marketing_offer_marketing_offer_detail_attributes_deep_link_member_id',
    'deep_link_member_resource_type': '#marketing_offer_marketing_offer_detail_attributes_deep_link_member_type'
  }

  const deepLinkMemberResourceEndpoints = {
    'homepage_member': '/admin/api/v1/brands',
    'individual_video': '/admin/api/v1/videos',
    'individual_live_class': '/admin/api/v1/live_classes',
    'program_detail_member': '/admin/api/v1/programs',
    'collection_detail_member': '/admin/api/v1/collections'
  }

  var initialLoad = true

  // Public Method
  marketinOffer.initForm = function() {
    $(formElements['enable_internal_deep_link']).on('change', function() {
      _setDeepLinkInput()
    });

    $(formElements['deep_link_resource']).on('change', function() {
      _setDeepLinkMembersDropdown()
    });

    _setDeepLinkInput()
  }

  function _setDeepLinkInput() {
    var internalEnabled = $(formElements['enable_internal_deep_link'])
    
    if(internalEnabled.is(':checked')){
      $(formElements['internal_deep_link_wrapper']).removeClass('hidden_input')
      $(formElements['deep_link_resource']).trigger('change');

      $(formElements['external_deep_link_wrapper']).addClass('hidden_input')
    }
    else{
      $(formElements['internal_deep_link_wrapper']).addClass('hidden_input')
      $(formElements['deep_link_resource_wrapper']).addClass('hidden_input')
      $(formElements['deep_link_member_resource_wrapper']).addClass('hidden_input')

      
      $(formElements['external_deep_link_wrapper']).removeClass('hidden_input')
    }
  }

  function _noMembersDeepLinkNeeded() {
    $(formElements['deep_link_member_resource_wrapper']).addClass('hidden_input')
    $(formElements['deep_link_member_resource']).val(null).trigger('change');
    $(formElements['deep_link_member_resource_type']).val('')
  }

  function _setDeepLinkMembersDropdown() {
    // 1. Get the current Deep Link ID
    var selectedDeepLink = $(formElements['deep_link_resource']).val() 
    // - Exit if no value is set yet, nothing to do here.
    if(selectedDeepLink == null || selectedDeepLink == '') {
      _noMembersDeepLinkNeeded()

      return 
    }

    // 2. Find the current Deep Link Object
    var selectedDeepLinkObject = _findDeepLinkObject(selectedDeepLink)
    // - Exit if the deep link is not a member type
    if(selectedDeepLinkObject.route_state == 'collection') {
      _noMembersDeepLinkNeeded()
      return 
    }
    
    // Clear the dropdown
    _noMembersDeepLinkNeeded()

    // Change Offer Type Listener
    $(formElements['deep_link_member_resource']).select2({
      placeholder: 'Select Deep Link Resource ...',
      allowClear: false,
      minimumInputLength: 2,
      ajax: {
        url: deepLinkMemberResourceEndpoints[selectedDeepLinkObject.identifier],
        dataType: 'json',
        data: function (params) {
          var query = {
            search: params.term
          }
          // Query parameters will be ?search=[term]
          return query;
        },
        processResults: function (data) {
          return {
            results: data
          };
        }
      }
    })

    $(formElements['deep_link_member_resource']).on('change', function() {
      _setDeepLinkmemberResourceType()
    });

    // Populate the Selected Element - this is on page load
    // It's done this way as limitation with select2 and ajax search
    var populateSelectedResource = app.marketinOffer.selectedDeepLinkResource
    if(Object.keys(populateSelectedResource).length > 0 && initialLoad){
      var newOption = new Option(populateSelectedResource.text, populateSelectedResource.id, true, true);
      $(formElements['deep_link_member_resource']).append(newOption).trigger('change');
      initialLoad = false
    }

    $(formElements['deep_link_member_resource_wrapper']).removeClass('hidden_input')
  }

  function _setDeepLinkmemberResourceType() {
    var selectedDeepLink = $(formElements['deep_link_resource']).val() 
    // - Exit if no value is set yet, nothing to do here.
    if(selectedDeepLink == null || selectedDeepLink == '') {
      return 
    }
    var selectedDeepLinkObject = _findDeepLinkObject(selectedDeepLink)
    $(formElements['deep_link_member_resource_type']).val(selectedDeepLinkObject.member_model)
  }

  function _findDeepLinkObject (deepLinkId) {
    return app.data.deepLinks.find(x => String(x.id) === String(deepLinkId))
  }

}( window.app ||= {}, 
  window.app.marketinOffer ||= {}, 
  jQuery 
));

(function ($) {
  $(function() {
    // INIT the Homepage Offer Slot form
    if ($('#edit_marketing_offer').length || $('#new_marketing_offer').length) {
      app.marketinOffer.initForm();
    }

    if ($('#edit_marketing_offer').length || $('#new_marketing_offer').length || $('.show_marketing_offer').length) {
      app.helpers.activeMenu('offer_management','offers')
    }

  })
})(jQuery);
